import { Injectable, inject } from '@angular/core';
import { AbstractCrudOperations, ServiceTransactionsEnum, RoleRequirements } from './abstract/abstract-crud-operations';
import { DocumentType, DocumentTypeCreate, DocumentTypeUpdate, Role } from './model';
import { AuthService } from './auth.service';

export enum DocumentTypeTransactionsEnum {
  GET_ALL = 'document-types-get-all',
  GET_BY_ID = 'document-types-get-by-id',
  CREATE = 'document-types-create',
  UPDATE = 'document-types-update',
  DELETE = 'document-types-delete',
}

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeService extends AbstractCrudOperations<DocumentType, DocumentTypeCreate, DocumentTypeUpdate> {
  protected override transactions: Record<ServiceTransactionsEnum, string> = {
    [ServiceTransactionsEnum.GET_ALL]: DocumentTypeTransactionsEnum.GET_ALL,
    [ServiceTransactionsEnum.GET_BY_ID]: DocumentTypeTransactionsEnum.GET_BY_ID,
    [ServiceTransactionsEnum.CREATE]: DocumentTypeTransactionsEnum.CREATE,
    [ServiceTransactionsEnum.UPDATE]: DocumentTypeTransactionsEnum.UPDATE,
    [ServiceTransactionsEnum.DELETE]: DocumentTypeTransactionsEnum.DELETE,
  };

  override readonly resource = 'document-types';

  protected override roleRequirements: RoleRequirements = {
    create: [Role.Admin, Role.Manager],
    update: [Role.Admin, Role.Manager, Role.User],
    delete: [Role.Admin, Role.Manager],
  };

  protected override authService = inject(AuthService);
}
